"use client";
import { useState } from "react";
import { Modal, Table, Button, Tag } from "antd";

export default function ErrorModal({ visible, onClose, errors }) {
  const [selectedError, setSelectedError] = useState(null);
  console.log({ errors });
  const columns = [
    {
      title: "Error",
      dataIndex: "err",
      key: "err",
      render: (text) => <Tag color="red">{text}</Tag>,
    },
    {
      title: "Row Preview",
      dataIndex: "item",
      key: "item",
      render: (row) => {
        const firstValues = Object.values(row).slice(0, 3); // show 3 values
        return <span>{firstValues.join(" | ")}</span>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button size="small" onClick={() => setSelectedError(record)}>
          View
        </Button>
      ),
    },
  ];

  return (
    <>
      <Modal
        title="Upload Errors"
        open={visible}
        onCancel={onClose}
        footer={[
          <Button key="close" onClick={onClose}>
            Close
          </Button>,
        ]}
        width={900}
      >
        <p>
          Found <b>{errors?.[visible]?.length}</b> errors. Please fix them
          before finishing the upload.
        </p>
        <Table
          rowKey={"rowIndex"}
          dataSource={errors?.[visible] || []}
          columns={columns}
          size="small"
          scroll={{ y: 400 }}
          pagination={true}
        />
      </Modal>

      <Modal
        title="Error Details"
        open={!!selectedError}
        onCancel={() => setSelectedError(null)}
        footer={[
          <Button key="close" onClick={() => setSelectedError(null)}>
            Close
          </Button>,
        ]}
        width={600}
      >
        {selectedError && (
          <pre className="bg-gray-100 p-2 rounded text-xs overflow-auto max-h-96">
            {JSON.stringify(selectedError, null, 2)}
          </pre>
        )}
      </Modal>
    </>
  );
}
